import type { DirectoryCard } from "@/features/directory/modules/search-results/components/result-card";
import { sdk } from "@/api/sdk";

/** Days of open times a card asks for, and how many of the open ones it shows. */
export const CARD_DAYS = 7;

/** A card's identity across pages: one person at one business. */
export const cardKey = (card: Pick<DirectoryCard, "organizationId" | "specialist">) =>
  `${card.organizationId}:${card.specialist.id}`;

/** One card's open times: the public availability of its person, for the service that matched. */
export const cardTimesRequest = (card: DirectoryCard, from?: string) =>
  sdk.bookingPublic.availability.$get.setQueryParams({
    organizationId: card.organizationId,
    sessionTypeId: card.service.id,
    specialistIds: [card.specialist.id],
    days: String(CARD_DAYS),
    ...(from ? { from } : {}),
  });
